import { Controller } from 'stimulus'

export default class extends Controller {
  toggle(event) {
    event.preventDefault();
    const kanbanListId  = event.currentTarget.dataset.kanbanListId;
    const kanbanList    = document.querySelector(`#kanban-list-${kanbanListId}`);
    const content       = kanbanList.querySelector('.kanbanlist');
    const header        = kanbanList.querySelector('.kanban-list-header');
    const settingsWrap  = kanbanList.querySelector('.kanban-list-settings-wrapper');
    const icon          = event.currentTarget.querySelector('.icon');
    const accountId     = document.body.dataset.accountId || window.accountId;
    const boardId       = kanbanList.dataset.boardId;

    const isCollapsed = kanbanList.classList.toggle('collapsed');
    content.classList.toggle('hidden', isCollapsed);

    if (header) header.classList.toggle('is-collapsed', isCollapsed);
    if (settingsWrap) settingsWrap.classList.toggle('hidden', isCollapsed);

    if (isCollapsed) {
      icon.classList.remove('icon-arrow-down2');
      icon.classList.add('icon-arrow-right2');
      event.currentTarget.title = 'Expand column';
    } else {
      icon.classList.remove('icon-arrow-right2');
      icon.classList.add('icon-arrow-down2');
      event.currentTarget.title = 'Collapse column';
    }

    fetch(`/${accountId}/boards/${boardId}/kanban_lists/${kanbanListId}/toggle_collapse`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      }
    }).catch(error => console.error('Error toggling collapse:', error));
  }
}
